// @flow

import { SET_PAYMENTAGREEMENT } from "../actions"

export default ( state: any = null, action: any ) => {
  switch ( action.type ) {
  case SET_PAYMENTAGREEMENT:
    return action.response
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentAgreementById.jsx